import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "history-table" }
const _hoisted_2 = { class: "t-table" }
const _hoisted_3 = { "data-qe-id": "table-data" }
const _hoisted_4 = ["onClick", "data-qe-id"]
const _hoisted_5 = ["colspan"]
const _hoisted_6 = { class: "accumulated-winnings" }
const _hoisted_7 = { class: "sum-winnings-label" }
const _hoisted_8 = { "data-qe-id": "prize-total" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "no-results",
  "data-qe-id": "no-results-available-row"
}

import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import { State } from '@/store/state'
import { ZoneHistoryState } from '@/store/modules/ranking/zoneHistory'
import { SortFilter, Sorting } from '@/model/ranking/Sorting'
import { FinishedTournament } from '@/model/ranking/FinishedTournament'
import { Zone } from '@/model/Zone'
import CTableHeadColumn from '@/components/ranking/CTableHeadColumn.vue'
import { jslog } from '@gd/jslog'
import { track } from '@/lib/track'

const COLSPAN_NUM = 5
const ENTRIES_PER_BATCH = 50

export default /*@__PURE__*/_defineComponent({
  __name: 'MZoneHistoryTable',
  props: {
    zoneId: {}
  },
  setup(__props: any) {

const props = __props
const router = useRouter()
const route = useRoute()
const store = useStore()

const SORT_FILTER = SortFilter
const entriesToRender = ref(ENTRIES_PER_BATCH)

function created() {
  store.dispatch('ranking/zoneHistory/fetch', props.zoneId).catch((err) => {
    jslog.send({ name: 'fatal', data: { message: `could not load zone history table for: ${props.zoneId}` } })
    console.error(err)
  })
}

const zoneHistory = computed((): ZoneHistoryState => {
  return store.state.ranking.zoneHistory as ZoneHistoryState
})

const accumulatedWinnings = computed((): string => {
  return store.getters['ranking/zoneHistory/accumulatedWinnings']()
})

/**
 * Range of FinishedRankings rendered on screen
 */
const finishedRankingsRange = computed((): Array<FinishedTournament> => {
  return store.getters['ranking/zoneHistory/rankings'](0, entriesToRender.value)
})

/**
 * Stored sorting preferences containing order and filter
 */
const activeSorting = computed((): Sorting => {
  return zoneHistory.value.sorting
})

/**
 * Amount of all FinishedRankings in store
 */
const maxEntries = computed(() => {
  return zoneHistory.value.rankings.length
})

function onShowMore() {
  if (entriesToRender.value + ENTRIES_PER_BATCH <= maxEntries.value) {
    entriesToRender.value += ENTRIES_PER_BATCH
    track({
      path: route.fullPath,
      id: 'zoneHistoryTable',
      elem: 'load-more',
    })
  } else {
    entriesToRender.value = maxEntries.value
  }
}

function onTournamentSelect(tournamentId: string) {
  const zone: Zone = (store.state as State).zone
  // store.commit('setActiveTournament', tournamentId)
  router.push(`/tournamentHistory/${zone.zoneId}/${tournamentId}`)
  track({
    id: 'zoneHistoryTable',
    elem: 'tournament-select',
    path: route.fullPath,
    data: tournamentId,
  })
}

function onToggleSorting(sorting: Sorting) {
  store.dispatch('ranking/zoneHistory/toggleSortingForFilter', sorting)
  track({
    id: 'zoneHistoryTable',
    elem: 'toggle-sorting',
    path: route.fullPath,
    data: `${sorting.filter}_${sorting.order}`,
  })
}
created()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createVNode(CTableHeadColumn, {
            width: "20%",
            "is-selected": activeSorting.value.filter === _unref(SORT_FILTER).Tournament,
            "sort-filter": _unref(SORT_FILTER).Tournament,
            "sort-order": activeSorting.value.order,
            onToggleSorting: onToggleSorting,
            "qe-id": "sort-by-tournament"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('table.columns.tournament')), 1)
            ]),
            _: 1
          }, 8, ["is-selected", "sort-filter", "sort-order"]),
          _createVNode(CTableHeadColumn, {
            width: "20%",
            "is-selected": activeSorting.value.filter === _unref(SORT_FILTER).Date,
            "sort-filter": _unref(SORT_FILTER).Date,
            "sort-order": activeSorting.value.order,
            onToggleSorting: onToggleSorting,
            "qe-id": "sort-by-competition-end"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('table.columns.date')), 1)
            ]),
            _: 1
          }, 8, ["is-selected", "sort-filter", "sort-order"]),
          _createVNode(CTableHeadColumn, {
            width: "20%",
            "is-selected": activeSorting.value.filter === _unref(SORT_FILTER).Rank,
            "sort-filter": _unref(SORT_FILTER).Rank,
            "sort-order": activeSorting.value.order,
            onToggleSorting: onToggleSorting,
            "qe-id": "sort-by-rank"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('table.columns.rank')), 1)
            ]),
            _: 1
          }, 8, ["is-selected", "sort-filter", "sort-order"]),
          _createVNode(CTableHeadColumn, {
            width: "20%",
            "is-selected": activeSorting.value.filter === _unref(SORT_FILTER).Score,
            "sort-filter": _unref(SORT_FILTER).Score,
            "sort-order": activeSorting.value.order,
            onToggleSorting: onToggleSorting,
            "qe-id": "sort-by-score"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('table.columns.score')), 1)
            ]),
            _: 1
          }, 8, ["is-selected", "sort-filter", "sort-order"]),
          _createVNode(CTableHeadColumn, {
            width: "20%",
            "is-selected": activeSorting.value.filter === _unref(SORT_FILTER).TotalWin,
            "sort-filter": _unref(SORT_FILTER).TotalWin,
            "sort-order": activeSorting.value.order,
            onToggleSorting: onToggleSorting,
            "qe-id": "sort-by-prize"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('table.columns.totalWin')), 1)
            ]),
            _: 1
          }, 8, ["is-selected", "sort-filter", "sort-order"])
        ])
      ]),
      _createElementVNode("tbody", _hoisted_3, [
        (finishedRankingsRange.value.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finishedRankingsRange.value, (entry, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  "data-qe-id": "tr-data"
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("a", {
                      onClick: ($event: any) => (onTournamentSelect(entry.tournamentId)),
                      "data-qe-id": `link-to-tournament--${entry.tournamentId}`
                    }, _toDisplayString(entry.tournamentName), 9, _hoisted_4)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$d(new Date(entry.competitionEnd))), 1),
                  _createElementVNode("td", null, _toDisplayString(entry.tournamentRank), 1),
                  _createElementVNode("td", null, _toDisplayString(entry.tournamentScore), 1),
                  _createElementVNode("td", null, _toDisplayString(entry.totalWin), 1)
                ]))
              }), 128)),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  colspan: COLSPAN_NUM - 1
                }, null, 8, _hoisted_5),
                _createElementVNode("td", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('table.zoneHistory.sumWinnings')), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(accumulatedWinnings.value), 1)
                ])
              ]),
              (maxEntries.value > entriesToRender.value)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _createElementVNode("td", {
                      class: "show-more-row",
                      colspan: COLSPAN_NUM,
                      onClick: onShowMore,
                      "data-qe-id": "show-more-link"
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('table.more.button')) + " ", 1),
                      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "icf-arrowBottom" }, null, -1))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("tr", _hoisted_10, [
              _createElementVNode("td", { colspan: COLSPAN_NUM }, _toDisplayString(_ctx.$t('table.more.no_results')), 1)
            ]))
      ])
    ])
  ]))
}
}

})